import { useHistory } from "react-router-dom";

import Thread from "./Thread";

function ThreadCard(props) {
  const { thread } = props;
  const history = useHistory();
  const permalink = `/thread/${thread._id}`;

  const handleCardClick = () => {
    history.push(permalink);
  };

  return (
    <button onClick={handleCardClick} className="text-left text-sm">
      <div className="shadow-md rounded-md m-2">
        <div className="h-72 overflow-hidden">
          <Thread thread={thread} hideCopy={true} thumbnail={true} />
        </div>
        <div className="bg-white p-4 flex justify-center rounded-md">
          <div className="px-4 py-1 border-2 border-indigo-500 rounded-md">
            Read More
          </div>
        </div>
      </div>
    </button>
  );
}

export default ThreadCard;
